import http from "../../core/services/http.service";

const LiveBidsService = {
  getSale(saleNo, params = {}) {
    return http.get(`/api/v1/auctions/${saleNo}/live-bidding/`, {params});
  },
  updateLot(params) {
    return http.patch(`/api/v1/lots/live-bidding/${params.uuid}/`, params);
  },
  saleExists(saleNo) {
    return http.get(`/api/v1/auctions/${saleNo}/live-bidding/exists/`);
  },
};

export default LiveBidsService;
